import { createRootRoute, Outlet } from '@tanstack/react-router';

// Legal/policy links live on the dedicated /about page (reached from the account
// menu) and in the login-page footer — the latter keeps them publicly reachable
// (unauthenticated + crawlable) from the payment origin for Razorpay review.
export const Route = createRootRoute({
  component: () => <Outlet />,
});
